	<a 
	class="link" 
	[routerLink]="route.subRoute ? route.path : route.entityUrl.path" 
	[queryParamsHandling]="queryParamsHandling" 
	[queryParams]="(queryParams$ | push)"
	routerLinkActive="active" 
	title="{{route.fieldTooltip ? route.fieldTooltip : ''}}"
	
>
	<span class="label">
		{{route.entityLabel}}
		<span class="under-line-container" ></span>
	</span>
	<span class="ripple-container" matRipple ></span>
</a>
